/**
 * Helper function to manage layout styles for components using Ariakit's Popover
 */
const assignStyle = (element, style) => {
  if (!element) return () => {};
  const previousStyle = element.style.cssText;
  Object.assign(element.style, style);
  const restorePreviousStyle = () => {
    // eslint-disable-next-line no-param-reassign
    element.style.cssText = previousStyle;
  };
  return restorePreviousStyle;
};

export { assignStyle };
